import { type SVGProps } from "react";

export const ClassScheduleSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <circle cx={39.95} cy={40.543} r={32} fill="#F1F5F9" transform="rotate(-.812 39.95 40.543)" />
    <path stroke="#535A68" strokeLinecap="round" strokeWidth={1.025} d="M22.55 29.456h7.431" />
    <rect
      width={51}
      height={55.5}
      x={16.25}
      y={14.75}
      fill="#fff"
      stroke="#000"
      strokeWidth={1.5}
      rx={3.25}
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M52.529 23.68a30.215 30.215 0 0 0-.246 3.173c1.44.601 2.818 1.34 4.116 2.205a24.306 24.306 0 0 1 4.116-2.205 30.215 30.215 0 0 0-.246-3.173m0 0c.438-.147.881-.283 1.33-.407a29.946 29.946 0 0 0-5.2-2.92 29.948 29.948 0 0 0-5.2 2.92 25.227 25.227 0 0 1 5.2 2.078 25.357 25.357 0 0 1 3.87-1.671Zm-6.495 2.426a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75Zm0 0V24.27a27.677 27.677 0 0 1 2.625-1.441m-3.504 5.775a2.99 2.99 0 0 0 .879-2.122v-.75"
    />
    <rect width={7} height={24} x={21.5} y={37.5} fill="#F1F5F9" rx={1.074} />
    <rect width={6.981} height={2.909} x={21.5} y={42.28} fill="#64748B" rx={1} />
    <rect width={6.981} height={2.909} x={21.5} y={46.934} fill="#CBD5E1" rx={1} />
    <rect width={6.981} height={2.909} x={21.5} y={56.242} fill="#94A3B8" rx={1} />
    <rect width={7} height={24} x={30.029} y={37.5} fill="#F1F5F9" rx={1.074} />
    <rect width={6.981} height={2.909} x={30} y={46.934} fill="#64748B" rx={1} />
    <rect width={6.981} height={2.909} x={30} y={56.242} fill="#CBD5E1" rx={1} />
    <rect width={7} height={24} x={38.53} y={37.5} fill="#F1F5F9" rx={1.074} />
    <rect width={6.981} height={2.909} x={38.53} y={42.28} fill="#94A3B8" rx={1} />
    <rect width={6.981} height={2.909} x={38.53} y={46.934} fill="#CBD5E1" rx={1} />
    <rect width={6.981} height={2.909} x={38.53} y={56.242} fill="#94A3B8" rx={1} />
    <rect width={7} height={24} x={47.03} y={37.5} fill="#F1F5F9" rx={1.074} />
    <rect width={6.981} height={2.909} x={47.03} y={46.934} fill="#64748B" rx={1} />
    <rect width={6.981} height={2.909} x={47.03} y={56.242} fill="#64748B" rx={1} />
    <rect width={7} height={24} x={55.53} y={37.5} fill="#F1F5F9" rx={1.074} />
    <rect width={6.981} height={2.909} x={55.53} y={42.28} fill="#94A3B8" rx={1} />
    <rect width={6.981} height={2.909} x={55.53} y={46.934} fill="#CBD5E1" rx={1} />
    <rect width={6.981} height={2.909} x={55.53} y={51.588} fill="#94A3B8" rx={1} />
    <rect width={6.981} height={2.909} x={55.53} y={56.242} fill="#CBD5E1" rx={1} />
    <path
      stroke="#000"
      strokeLinecap="square"
      strokeWidth={1.025}
      d="M20.5 22.5h12.3M20.5 24.55h10.506M20.5 26.6h12.556M33.5 34.5h17.425"
    />
  </svg>
);
